<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button type="danger" style="margin-right: 10px" @click="$refs.created.openDialog()">新 增</el-button>
      <el-input v-model="tableQuery.name" style="width: 160px;" @change="selectPage" placeholder="请输入院校名称"></el-input>
      <el-button type="danger" style="margin: 0 10px">搜 索</el-button>
    </div>
    <el-table border class="table" :data="tableData" height="600px" v-loading="tableQuery.loading" empty-text="空空如也～新增一条吧！">
      <el-table-column prop="name" label="院校名称" width="280" show-overflow-tooltip/>
      <el-table-column prop="addTime" label="合作时效" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.startTime }} ~ {{ scope.row.endTime }}
        </template>
      </el-table-column>
      <el-table-column prop="addTime" show-overflow-tooltip>
        <template #header>
          <div style="cursor: pointer;display: flex;align-items: center" v-popover:popover>
            状态
            <svg-icon
                icon-class="filter"
                style="font-size: 19px; margin-left: 4px"
                :style="{ color: tableQuery.state.length > 0 ? '#ff4d4f' : '' }"/>
          </div>
          <el-popover ref="popover" placement="top-start" width="80" trigger="hover">
            <div>
              <el-checkbox-group v-model="tableQuery.state">
                <el-checkbox style="margin: 4px;width: 76px" :label="1">洽谈中</el-checkbox>
                <el-checkbox style="margin: 4px;width: 76px" :label="2">合作中</el-checkbox>
                <el-checkbox style="margin: 4px;width: 76px" :label="3">已到期</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-popover>
        </template>
        <template #default="scope">
          <el-tag v-if="scope.row.state === 1" type="default">洽谈中</el-tag>
          <el-tag v-if="scope.row.state === 2" type="success">合作中</el-tag>
          <el-tag v-if="scope.row.state === 3" type="danger">已到期</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="explain" label="说明" show-overflow-tooltip/>
      <el-table-column
          prop="addTime"
          label="创建日期"
          width="180">
      </el-table-column>
      <el-table-column label="操作" width="110" align="center">
        <template #default="scope">
          <div style="margin-right: 4px;">
            <el-button type="text" size="small" style="margin-right: 10px;color:#409EFF"
                       @click.prevent="updateItem(scope.row)">编辑
            </el-button>
            <el-popconfirm title="确定要删除吗？" @confirm="deleteItem(scope.row.id)">
              <el-button slot="reference" type="text" size="small" style="color: red;">删除</el-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.total">
    </el-pagination>
    <created-school @refresh="selectPage" ref="created"/>
    <update-school @refresh="selectPage" ref="update"/>
  </div>
</template>

<script>
import {deleteSchool, selectSchoolPage} from "/src/api/contacts/hr/cooperationSchool.js";
import CreatedSchool from "./CreatedSchool";
import UpdateSchool from "./UpdateSchool";

export default {
  name: "CooperationSchool",
  components: {
    CreatedSchool, UpdateSchool
  },
  data() {
    return {
      tableData: [
        {
          id: 1,
          name: "北京大学",
          startTime: "2024-01-01 00:00:00",
          endTime: "2025-01-01 23:59:59",
          state: 2,
          explain: "深度合作院校，优先推荐",
          addTime: "2024-01-01 10:00:00"
        },
        {
          id: 2,
          name: "清华大学",
          startTime: "2024-02-01 00:00:00",
          endTime: "2025-02-01 23:59:59",
          state: 2,
          explain: "战略合作院校，资源共享",
          addTime: "2024-02-01 11:00:00"
        },
        {
          id: 3,
          name: "复旦大学",
          startTime: "2023-03-01 00:00:00",
          endTime: "2024-03-01 23:59:59",
          state: 3,
          explain: "合作已到期，待续签",
          addTime: "2023-03-01 09:30:00"
        },
        {
          id: 4,
          name: "浙江大学",
          startTime: "2024-04-01 00:00:00",
          endTime: "2024-10-01 23:59:59",
          state: 1,
          explain: "洽谈中，初步达成合作意向",
          addTime: "2024-04-01 14:20:00"
        },
        {
          id: 5,
          name: "上海交通大学",
          startTime: "2024-05-01 00:00:00",
          endTime: "2025-05-01 23:59:59",
          state: 2,
          explain: "长期稳定合作院校",
          addTime: "2024-05-01 16:10:00"
        }
      ],
      tableQuery: {
        name: "",
        state: [],
        pageIndex: 0,
        pageSize: 11,
        loading: false,
        total: 0
      }
    }
  },
  methods: {
    changePage(index) {
      this.tableQuery.pageIndex = index;
      this.selectPage();
    },
    selectPage() {
      this.tableQuery.loading = true;
      selectSchoolPage(this.tableQuery).then(val => {
        this.tableQuery.loading = false;
        if (val.status == 200) {
          this.tableData = val.data.list;
          this.tableQuery.total = val.data.total;
        }
      })
    },
    updateItem(item) {
      this.$refs.update.openDialog(item);
    },
    deleteItem(id) {
      deleteSchool(id).then(val => {
        if (val.status) {
          this.selectPage();
          this.$notify.success({title: '提示', message: '删除成功！', offset: 40});
        } else {
          this.$notify.error({title: '删除失败！', message: val.data, offset: 40});
        }
      })
    }
  },
  created() {
    // this.selectPage();
  }
}
</script>

<style scoped>

</style>